import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAuth from "@/hooks/stores/useAuth";

export const PaymentStatusMiddleware = () => {
  const { userFlow, paymentStatus, isAuthenticated } = useAuth();
  const location = useLocation();

  // Don't apply payment checks to paywall page itself to avoid infinite redirects
  const isPaywallPage = location.pathname === "/paywall";
  
  // Debug logging to track what's happening
  console.log("PaymentStatusMiddleware Debug:", {
    userFlow,
    paymentStatus,
    isAuthenticated,
    pathname: location.pathname,
    isPaywallPage
  });

  // IMPORTANT: Only apply payment status checks for REMOTE users
  // In-person users should never be blocked by payment status
  if (isAuthenticated && !isPaywallPage && userFlow === 'remote') {
    // Block remote users with pending payment status
    if (paymentStatus === 'pending') {
      console.log("🔒 BLOCKING ACCESS - Remote user with pending payment, redirecting to paywall");
      return <Navigate to="/paywall" replace />;
    }

    // Block remote users with failed payment status (redirect to welcome video)
    if (paymentStatus === 'failed') {
      console.log("🔒 BLOCKING ACCESS - Remote user with failed payment, redirecting to welcome video");
      return <Navigate to="/welcome-video" replace />;
    }

    // Block remote users who don't have any payment status set
    // IMPORTANT: Handle both null values AND string "null" values
    if (!paymentStatus || paymentStatus === null || paymentStatus === undefined || paymentStatus === 'null') {
      console.log("🔒 BLOCKING ACCESS - Remote user with no/null payment status, redirecting to paywall");
      return <Navigate to="/paywall" replace />;
    }
  }

  // Log access decisions for debugging
  if (isAuthenticated && userFlow === 'remote' && paymentStatus === 'completed') {
    console.log("✅ Remote user with completed payment - allowing access");
  } else if (isAuthenticated && userFlow === 'in-person') {
    console.log("✅ In-person user - allowing access (payment status ignored)");
  } else if (!isAuthenticated) {
    console.log("✅ Not authenticated - allowing access to public routes");
  } else if (isPaywallPage) {
    console.log("✅ On paywall page - allowing access");
  }

  return <Outlet />;
}; 